import { Injectable } from '@angular/core';
import { DbService } from '../db/db.service';
import { OurProject } from 'src/app/models/firebase/our-project';
@Injectable({
  providedIn: 'root'
})
export class OurProjectsService {

    constructor(
        private dbService: DbService,
    ) { }

    async getProjects(projectId: string){
        const data = await this.dbService.getData(projectId, OurProject.PATH);
        return data.docs.map((x) => x.data() as OurProject);
    }

}
